import { useMemo } from 'react';
import * as yup from 'yup';
import {
  ScoreUpVariables,
  useChallengeScore,
  useScoreUpCriteria,
} from '~/components/Challenge/Score/ChallengeScore.hooks';

export type ChallengeScoreUpValues = {
  balance: number;
} & ScoreUpVariables;

export const useScoreUpSchema = () => {
  const {
    data: { joinForAssetAmount, maxCountPerJoin },
  } = useScoreUpCriteria();
  const {
    data: { scoreUpMaxCount, scoreUpCount },
  } = useChallengeScore();

  return useMemo(
    () =>
      yup.object({
        balance: yup.number().required(),
        count: yup
          .number()
          .min(1, 'MIN_COUNT')
          .test({
            name: 'MAX_COUNT',
            message: 'MAX_COUNT',
            test: (value = 0) =>
              scoreUpCount + value <= scoreUpMaxCount && value <= maxCountPerJoin,
          })
          .test({
            name: 'NOT_ENOUGH_BALANCE',
            message: 'NOT_ENOUGH_BALANCE',
            test: (value = 0, testContext) =>
              value * joinForAssetAmount <= testContext.parent.balance,
          })
          .required(),
      }),
    [joinForAssetAmount, maxCountPerJoin, scoreUpCount, scoreUpMaxCount]
  );
};
